import { useMutation } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { CreateCheckoutSessionType } from "@reflag/shared/organizationAPI";

export function useCheckoutSession() {
  const { org } = useEnvironment();

  return useMutation({
    mutationFn: async ({
      successUrl,
      cancelUrl,
      paymentTerms,
    }: CreateCheckoutSessionType) => {
      const response = await api.post<"/orgs/:orgId/checkout-session">(
        `/orgs/${org.id}/checkout-session`,
        {
          successUrl,
          cancelUrl,
          paymentTerms,
        },
      );

      return response.data;
    },
  });
}
